/**
 * Device Manager for Monochrome Remote Control.
 * Tracks current playback device and manages transfer state.
 */

const DEVICE_KEY = 'monochrome-device';
const TRANSFER_KEY = 'monochrome-pending-transfer';

class DeviceManager {
    constructor() {
        this._device = localStorage.getItem(DEVICE_KEY) || 'local';
        this._desktopConnected = false;
        this._callbacks = new Set();
    }

    getCurrentDevice() {
        return this._device;
    }

    setCurrentDevice(device) {
        this._device = device;
        localStorage.setItem(DEVICE_KEY, device);
        this._notify();
    }

    isDesktopConnected() {
        return this._desktopConnected;
    }

    setDesktopConnected(connected) {
        this._desktopConnected = connected;
        this._notify();
    }

    switchToDesktop() {
        this.setCurrentDevice('desktop');
    }

    switchToLocal() {
        this.setCurrentDevice('local');
    }

    /**
     * Store pending transfer state for page reloads.
     */
    setPendingTransfer(state) {
        try {
            localStorage.setItem(TRANSFER_KEY, JSON.stringify(state));
        } catch {}
    }

    getPendingTransfer() {
        try {
            const data = localStorage.getItem(TRANSFER_KEY);
            if (data) {
                localStorage.removeItem(TRANSFER_KEY);
                return JSON.parse(data);
            }
        } catch {}
        return null;
    }

    onChange(callback) {
        this._callbacks.add(callback);
        return () => this._callbacks.delete(callback);
    }

    _notify() {
        const state = {
            device: this._device,
            desktopConnected: this._desktopConnected,
        };
        for (const cb of this._callbacks) {
            try {
                cb(state);
            } catch (e) {
                console.error('DeviceManager callback error:', e);
            }
        }
        window.dispatchEvent(new CustomEvent('device-changed', { detail: state }));
    }
}

export const deviceManager = new DeviceManager();
